module.exports = __webpack_public_path__ + "static/media/audio-icon.d1a3198a.svg";